module.exports = __webpack_public_path__ + "static/metaimage-0aa2dfeb1d70f5520f4ad9131f975179.png";